// extracted by mini-css-extract-plugin
export default {"containerBanner":"BannerMobile_containerBanner__loeLJ","content":"BannerMobile_content__BJRzC"};